import img1 from "./WhatsApp Image 2025-11-27 at 2.04.54 PM (1).jpeg";
import img2 from "./WhatsApp Image 2025-11-27 at 2.04.54 PM.jpeg";
import img3 from "./WhatsApp Image 2025-11-27 at 2.04.55 PM (1).jpeg";
import img4 from "./WhatsApp Image 2025-11-27 at 2.04.55 PM (2).jpeg";
import img5 from "./WhatsApp Image 2025-11-27 at 2.04.55 PM.jpeg";
import img6 from "./WhatsApp Image 2025-11-27 at 2.04.56 PM (1).jpeg";
import img7 from "./WhatsApp Image 2025-11-27 at 2.04.56 PM (2).jpeg";
import img8 from "./WhatsApp Image 2025-11-27 at 2.04.56 PM.jpeg";
import img9 from "./WhatsApp Image 2025-11-27 at 2.04.57 PM (1).jpeg";
import img10 from "./WhatsApp Image 2025-11-27 at 2.04.57 PM (2).jpeg";
import img11 from "./WhatsApp Image 2025-11-27 at 2.04.57 PM.jpeg";

export default [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
];
